module.exports = __webpack_public_path__ + "static/media/video-cpg-1.a5ba9c77.mp4";